import { render, staticRenderFns } from "./VerificaRecuperoPassword.vue?vue&type=template&id=76d196ac&scoped=true&"
import script from "./VerificaRecuperoPassword.vue?vue&type=script&lang=ts&"
export * from "./VerificaRecuperoPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d196ac",
  null
  
)

export default component.exports